import toast from 'react-hot-toast';

/**
 * Trigger an Alert ("Toast") that will show up
 * in the app for a few seconds. The duration can be
 * controlled with the `duration` prop.
 */

function setAlert(data) {
  var title = data.title,
    key = data.key,
    duration = data.duration,
    suppressTimeout = data.suppressTimeout;

  // Many of the options we have for controlling the
  // appearance and functionality of alerts are not
  // natively supported by the react-hot-toast library,
  // so we pass our options through in a `data` object
  // that shouldn't collide with its native API.
  //
  // Our custom alerts are then rendered using the library's
  // "headless" mode.

  toast(title, {
    id: key,
    duration: suppressTimeout ? Infinity : duration,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore we pass our options through in a `data` object that shouldn't collide with its native API.
    data: data
  });
}
export default setAlert;